module.exports = __webpack_public_path__ + "static/media/fluid-turquoise.48838ad5.png";